import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IUniqueVoucherGenerated } from '@/shared/model/unique-voucher-generated.model';

const baseApiUrl = 'api/unique-voucher-generateds';
const baseSearchApiUrl = 'api/_search/unique-voucher-generateds?query=';

export default class UniqueVoucherGeneratedService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IUniqueVoucherGenerated> {
    return new Promise<IUniqueVoucherGenerated>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IUniqueVoucherGenerated): Promise<IUniqueVoucherGenerated> {
    return new Promise<IUniqueVoucherGenerated>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IUniqueVoucherGenerated): Promise<IUniqueVoucherGenerated> {
    return new Promise<IUniqueVoucherGenerated>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
